import React from "react";
import ReactPlayer from "react-player";
import textSizeBasedOnLength from "../../funcs/textResizer";
import { TeamRail, TeamAvatar, VoteCount, voteTargetClasses } from "./liveUi";

const Media = ({ a }) => {
  if (a?.answerVideo && a.answerVideo.length > 10) {
    return (
      <ReactPlayer url={a.answerVideo} controls width="100%" height="100%" />
    );
  }
  if (a?.answerAudio && a.answerAudio.length > 10) {
    return (
      <div className="w-full h-full flex flex-col justify-center items-center">
        <div className="w-full max-w-md bg-gray-100 p-6 rounded-xl shadow-md">
          <audio src={a.answerAudio} controls className="w-full" />
        </div>
      </div>
    );
  }
  if (a?.answerImage && a.answerImage.length > 10) {
    return (
      <img src={a.answerImage} alt="إجابة" className="h-full object-contain" />
    );
  }
  return <div className="w-full h-full flex justify-center items-center" />;
};

// Read-only mirror of the answer screen — frame copied from
// components/tarbaa/Answer.js. Vote targets: which team answered (chips at
// the bottom, where the master's "منو جاوب" lives) and "السؤال" (back).
const LiveAnswer = ({ state, presence, voting }) => {
  const a = state?.answer;
  const q = state?.question;
  const teams = state?.teams || [];
  const backMine = voting.myVote === "back";

  const teamChip = (key, label, team) => {
    const mine = voting.myVote === key;
    const count = voting.counts?.[key] || 0;
    return (
      <button
        key={key}
        onClick={() => voting.tap("answer", key)}
        className={`relative flex items-center gap-2 bg-secondaryButton hover:bg-secondaryButtonShadow text-white font-bold py-2 px-3 md:px-4 border-b-4 border-secondaryButtonShadow rounded-md text-xs md:text-lg ${voteTargetClasses(
          mine,
          voting.canVote
        )}`}
      >
        <VoteCount count={count} />
        {team && (
          <span className="w-5 h-5 md:w-7 md:h-7 rounded-full overflow-hidden">
            <TeamAvatar team={team} />
          </span>
        )}
        {label}
      </button>
    );
  };

  return (
    <div className="w-full h-[90vh] flex flex-col portrait:flex-col sm:flex-row portrait:py-10 pl-10 pr-2 py-10 xl:py-20">
      <div
        className={`portrait:w-full portrait:h-3/4 relative h-3/4 w-full sm:w-5/6 sm:h-full ${textSizeBasedOnLength(
          a?.text
        )} font-bold text-dark border-8 border-behindButton rounded-[50px]`}
      >
        {/* Floating top badges */}
        <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-11/12 sm:w-full flex flex-row justify-between items-center bg-transparent">
          <div className="w-1/3 flex justify-center items-center">
            <div className="hidden sm:block border-[#343434] border-4 rounded-2xl">
              <div className="text-center p-1 px-4 xl:p-2 bg-[#343434] text-white rounded-lg text-sm xl:text-xl">
                {q?.modeName}
              </div>
            </div>
          </div>
          <div className="w-1/3 flex justify-center items-center">
            <div className="p-1 px-4 md:p-3 bg-[#343434] text-white rounded-full flex items-center gap-3 text-sm xl:text-xl">
              <span className="w-2.5 h-2.5 rounded-full bg-danger animate-pulse" />
              <h1 className="text-center">الإجابة</h1>
            </div>
          </div>
          <div className="w-1/3 flex justify-center items-center">
            <div className="hidden sm:block border-[#343434] border-4 rounded-2xl">
              <div className="text-right p-1 px-4 xl:p-2 bg-[#343434] text-white rounded-lg text-sm xl:text-xl flex gap-1">
                <div>نقطة</div>
                <div>{q?.points}</div>
              </div>
            </div>
          </div>
        </div>

        {/* Answer content */}
        <div className="h-2/6 md:h-1/6 w-full flex flex-col justify-center items-center p-2 px-4 md:px-10 pt-6">
          <div className="flex-1 flex items-center justify-center">
            <h1
              style={{ direction: "rtl", textAlign: "center" }}
              className="leading-relaxed"
            >
              {a?.text}
            </h1>
          </div>
        </div>
        <div className="h-4/6 md:h-5/6 w-full flex justify-center items-start px-4 pb-4 md:p-10">
          <Media a={a} />
        </div>

        {/* Who-answered votes — bottom center, where the master's منو جاوب sits */}
        <div
          className="absolute bottom-0 left-1/2 transform -translate-x-1/2 translate-y-1/2 flex flex-row flex-wrap justify-center gap-2 max-w-[80%]"
          style={{ direction: "rtl" }}
        >
          {teams.map((team) => teamChip(`team:${team.id}`, team.name, team))}
          {teamChip("nobody", "محد جاوب", null)}
        </div>

        {/* Back-to-question vote — bottom right, same as the master's button */}
        <div className="absolute bottom-0 transform -translate-x-1/2 translate-y-1/2 right-0 text-white rounded-lg text-sm xl:text-xl">
          <button
            onClick={() => voting.tap("answer", "back")}
            className={`relative bg-mainButton hover:bg-mainButtonShadow text-white font-bold py-3 px-4 md:px-10 border-b-8 border-mainButtonShadow rounded-md text-sm md:text-xl ${voteTargetClasses(
              backMine,
              voting.canVote
            )}`}
          >
            <VoteCount count={voting.counts?.back || 0} />
            السؤال
          </button>
        </div>
      </div>

      <TeamRail state={state} presence={presence} voting={voting} />
    </div>
  );
};

export default LiveAnswer;
